<div *ngIf="subHeader" class="divider-bar w-8 mr-1 h-px bg-gray-200"></div>
<div class="flex-shrink-0 block pr-1 text-xs text-gray-300 uppercase">{{label}}</div>
<div class="divider-bar w-full h-px bg-gray-200"></div>